module.exports = __webpack_public_path__ + "static/crokektoeck-2838bcccc2d35ecabfcd16bea56cb453.jpeg";